// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-content-header {
  position: relative;
  width: 100%;
}

.side-panel-image {
  height: 150px;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.side-panel-button {
  display: flex;
  justify-content: end;
  margin: 20px 20px 0 0;
}

.profile-header-img {
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.panel-content {
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 20px;
}

.panel-content-text {
  padding-bottom: 20px;
}

.panel-content-subline {
  padding-top: 5px;
  color: var(--planeed-gray);
}

.panel-content-subline-bold {
  margin-left: 5px;
  font-weight: bold;
  color: var(--planeed-blue);
  font-size: 16px;
  line-height: 24px;
}

.panel-content-description {
  color: var(--planeed-gray);
}

.panel-content-moment {
  height: 100%;
  width: 100%;
}

.panel-content-header-action {
  position: relative;
  width: 100%;
  height: 100%;
}

.side-panel-image-action {
  height: 33%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.point-of-action-data {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.point-of-action-location {
  display: flex;
  align-items: center;
}

.point-of-action-location-text {
  color: var(--planeed-gray);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.point-of-action-creator {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.point-of-action-icon {
  font-size: 20px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.point-of-action-creator-image {
  height: 30px;
  width: 30px;
  object-fit: cover;
  overflow: hidden;
  border-radius: 5px;
}

.text-content-introduction {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--planeed-blue);
}

.action-point-creator-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-left: 5px;
  color: var(--planeed-blue);
}

.side-panel-action-point-list {
  display: flex;
  flex-direction: column;
}

.action-point-element {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
}

.action-point-element-data {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 10px;
  padding-right: 10px;
  color: var(--planeed-blue);
  max-width: 60%;
}

.action-point-image {
  width: 75px;
  height: 75px;
  object-fit: cover;
  overflow: hidden;
  border-radius: 6px;
  cursor: pointer;
}

.action-point-element-data-headline {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-point-element-data-author {
  display: flex;
  align-items: center;
}

.action-point-element-data-author-bold {
  font-weight: 500;
  color: var(--planeed-blue);
  margin-left: 5px;
  cursor: pointer;
}

.action-point-element-data-author-bold:hover {
  text-decoration: underline;
}

.action-point-element-circle {
  margin-left: auto;
  border: 2px solid var(--planeed-orange);
  border-radius: 50px;
  width: 57px;
  height: 57px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}
.action-point-element-circle ion-icon {
  padding-top: 3px;
}

.circle-stat-count {
  color: var(--planeed-orange);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.count-group-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.count-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.action-point-element-timestamp {
  color: var(--planeed-dark-gray);
}

.side-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.panel-header {
  flex: 0 0 auto;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.panel-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.segment-content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  --background: var(--planeed-color-white);
}

.posts-container {
  height: 100%;
  overflow-y: auto;
  padding-right: 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.posts-container::-webkit-scrollbar {
  display: none;
}

.panel-content-link-container {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.panel-content-link-icon {
  margin-right: 5px;
  height: 25px;
  width: 25px;
}

.panel-content-link {
  margin-top: 5px;
  color: var(--planeed-blue);
  text-decoration: none;
}

.panel-content-link:hover {
  text-decoration: underline;
}

.map-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 19;
  left: 0;
  top: 0;
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
